"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _GtmStartEvent = require("./GtmStartEvent");
Object.keys(_GtmStartEvent).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _GtmStartEvent[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _GtmStartEvent[key];
    }
  });
});